/*********************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                  is prohibited.
 *
 * Name          : NonMSASOConfirmConfiguration.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Sep 29, 2020
 *
 * @Version      : Version 1.0
 *
 * By             : H422337
 * On             : Sep 29,2020
 * Description    : ASDS-3257 APU enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 30,2020
 * Description    : ASDS-3230 APU enhancements as part of phase-2
********************************************************************************/
import  * as React from 'react';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import DisplayCustTypeCard from './DisplayCustTypeCard';
import DisplayPurchaseTypeCard from './DisplayPurchaseTypeCard';
import NonMSAServiceOrderConfigSummary from './NonMSAServiceOrderConfigSummary';
import CheckoutConstants from '../constants/checkout-constants';
import DisplayTotalPriceCard from './TotalPriceCard';

interface IConfigureProductProps {
    gotoCustomerCategoryTab: Function;
    gotoProductConfigureTab: Function;
    gotoProductPurchaseTab: Function;
    totalPrice: any;
    purchaseType: number;
    productData: IServiceOrderProductData[];
}

interface IServiceOrderProductData {
    acOem: string;
    oemError: string;
    serialNumber: string;
    serialNumberError: string;
    serviceOrderNumber: string;
    serviceOrderNumberError: string;
    unitPrice: number;
    subProductId: string;
}

class NonMSASOConfirmConfugration extends React.Component<IConfigureProductProps> {

  render() {
         return(
             <div>
                    <DisplayCustTypeCard gotoCustomerCategoryTab={this.props.gotoCustomerCategoryTab} customerType={CheckoutConstants.CUSTOMER_CATEGORY_NONMSA}/>
                    <DisplayPurchaseTypeCard gotoProductPurchaseTab={this.props.gotoProductPurchaseTab} purchaseTypeSubText={CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO}/>
                    <NonMSAServiceOrderConfigSummary gotoProductConfigureTab={this.props.gotoProductConfigureTab} productConfigData={this.props.productData} />
                    <DisplayTotalPriceCard totalPrice={this.props.totalPrice}/>
             </div>
         );

  }

}
const mapDispatchToProps = {
    gotoCustomerCategoryTab: ConfigureAPUActions.gotoCustomerCategoryTab,
    gotoProductConfigureTab: ConfigureAPUActions.gotoNonMsaProductConfigureTab,
    gotoProductPurchaseTab: ConfigureAPUActions.gotoProductConfigureTab,
};
function mapStateToProps(state) {

    return {
        totalPrice: state.configAPUData.payload.totalPrice,
        purchaseType: state.configAPUData.payload.purchaseType,
        productData: state.configAPUData.payload.nonMsaServiceOrderConfigData,
    };

  }

export default connect(mapStateToProps, mapDispatchToProps) (NonMSASOConfirmConfugration);